import { Component, inject } from "@angular/core";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { ItemLinkableBase } from "@app/shared/linkable/item-linkable-base";
import { Observable, firstValueFrom } from "rxjs";
import { IHasGuid } from "@app/shared/interfaces/IHasGuid";
import { IncidentService } from "../services/incident.service";
import { TranslocoService, provideTranslocoScope } from "@jsverse/transloco";
import { LinkableComponent } from "@app/shared/linkable/linkable.component";

@Component({
    selector: "incident-linkable",
    templateUrl: "./incident-linkable.component.html",
    styleUrls: ["./incident-linkable.component.scss"],
    imports: [LinkableComponent],
    providers: [provideTranslocoScope("incident")],
})
export class IncidentLinkableComponent extends ItemLinkableBase {
    private _incidentDS = inject(IncidentService);
    private _pages = inject(Pages);
    private _tabService = inject(TabService);
    private _translocoService = inject(TranslocoService);

    hasAccessToItem(guid: string): Observable<boolean> {
        return this._incidentDS.hasAccessToIncident(guid);
    }

    async openTab(item: IHasGuid, hasAccess: boolean) {
        if (hasAccess) {
            this._tabService.generateTab(
                this._pages.IncidentDetail,
                item.guid,
                `(I) ${item[this.displayValueProp]}`
            );
        } else {
            // Nothing in this template uses the transloco pipe/directive, so the lazy scope
            // is not loaded yet and a synchronous translate() would return the raw key.
            await firstValueFrom(
                this._translocoService.load(`incident/${this._translocoService.getActiveLang()}`)
            );
            this._toastr.warning(
                this._translocoService.translate("incident.incidentLinkable.notEnoughRights")
            );
        }
    }
}
